import React from 'react'
import CommonTotalMeasure from 'components/insightContent/Overview/DetailItems/TotalMeasure/CommonTotalMeasure'
import StarRatingsTotalMeasure from 'components/insightContent/Overview/DetailItems/TotalMeasure/StarRatingsTotalMeasure'
import SurveyScoresTotalMeasure from 'components/insightContent/Overview/DetailItems/TotalMeasure/SurveyScoresTotalMeasure'
import NameMeasureBy from 'components/insightContent/Overview/DetailItems/SingleMeasure/NameMeasureBy'
import NameMeasure from 'components/insightContent/Overview/DetailItems/SingleMeasure/NameMeasure'
import NameMeasureWithShareOfInsights from 'components/insightContent/Overview/DetailItems/SingleMeasure/NameMeasureWithShareOfInsights'
import NameMeasureWithShareOfSentiment from 'components/insightContent/Overview/DetailItems/SingleMeasure/NameMeasureWithShareOfSentiment'
import SelectedItemMeasure from 'components/insightContent/Overview/DetailItems/CrosstabMeasure/SelectedItemMeasure'
import MeasureWithLocalTime from 'components/insightContent/Overview/DetailItems/MeasureWithLocalTime'
import TopicComparison from 'components/insightContent/Overview/DetailItems/TopicComparison'
import MeasureWithInsight from 'components/insightContent/Overview/DetailItems/MeasureWithInsights'
import AllTopicsTotalMeasure from 'components/insightContent/Overview/DetailItems/CrosstabMeasure/AllTopicsTotalMeasure'
import AllTopicsAverageMeasure from 'components/insightContent/Overview/DetailItems/CrosstabMeasure/AllTopicsAverageMeasure'
import ShareOfColumns from 'components/insightContent/Overview/DetailItems/CrosstabMeasure/ShareOfColumns'
import ShareOfRows from 'components/insightContent/Overview/DetailItems/CrosstabMeasure/ShareOfRows'
import ColumnAverageDiff from 'components/insightContent/Overview/DetailItems/CrosstabMeasure/ColumnAverageDiff'
import RowAverageDiff from 'components/insightContent/Overview/DetailItems/CrosstabMeasure/RowAverageDiff'
import CountType, { CountTypeStrings } from 'enums/CountType'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import InsightViewOption from 'enums/InsightViewOption'
import MeasureWithSentiment from 'components/insightContent/Overview/DetailItems/MeasureWithSentiment'
import NetSentiment from 'components/insightContent/Overview/DetailItems/NetSentiment'
import TrendingSingleMeasure from 'components/insightContent/Overview/DetailItems/TrendingMeasure/SingleMeasure'
import TrendingTotalMeasure from 'components/insightContent/Overview/DetailItems/TrendingMeasure/TotalMeasure'
import OverallStarRatingsAverage from '../Overview/DetailItems/OverallStarRatingsAverage'
import OverallSurveyScoresAverage from '../Overview/DetailItems/OverallSurveyScoresAverage'
import Soundbite from '../Soundbite'
import InsightContentType, { InsightContentTypeStrings } from '../enum/InsightContentType'
import { InsightContentSettingType } from '../types'
import Replies from '../TopAuthors/Replies'
import Reposts from '../TopAuthors/Reposts'
import Mentions from '../TopAuthors/Mentions'
import Comment from '../Comment'

const getInsightContent = ({
  insightContentType,
  detailSetting,
  countType,
  timeUnits,
  forceNotScale,
  renderNameMeasureTitleContent,
  widgetId,
  isAudienceQuery
}: {
  insightContentType: InsightContentTypeStrings
  detailSetting: InsightContentSettingType
  countType?: CountTypeStrings
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
  renderNameMeasureTitleContent?: () => React.ReactNode
  widgetId?: number
  isAudienceQuery?: boolean
}) => {
  const getTotalMeasure = () => {
    const { viewOption } = detailSetting
    switch (viewOption) {
      case InsightViewOption.STAR_RATINGS:
        return (
          <StarRatingsTotalMeasure
            detailSetting={detailSetting}
            timeUnits={timeUnits}
            forceNotScale={forceNotScale}
          />
        )

      case InsightViewOption.SURVEY_SCORES:
        return (
          <SurveyScoresTotalMeasure
            detailSetting={detailSetting}
            timeUnits={timeUnits}
            forceNotScale={forceNotScale}
          />
        )

      default:
        return (
          <CommonTotalMeasure
            detailSetting={detailSetting}
            countType={countType || CountType.POSTS}
            timeUnits={timeUnits}
            forceNotScale={forceNotScale}
          />
        )
    }
  }

  switch (insightContentType) {
    case InsightContentType.TOTAL_MEASURE:
      return getTotalMeasure()

    case InsightContentType.CROSSTAB_TOTAL_MEASURE:
      return (
        <AllTopicsTotalMeasure
          detailSetting={detailSetting}
          widgetId={widgetId!}
          isAudienceQuery={isAudienceQuery!}
        />
      )

    case InsightContentType.CROSSTAB_AVERAGE_MEASURE:
      return (
        <AllTopicsAverageMeasure
          detailSetting={detailSetting}
          widgetId={widgetId!}
          isAudienceQuery={isAudienceQuery!}
        />
      )

    case InsightContentType.CROSSTAB_SHARE_OF_COLUMNS:
      return (
        <ShareOfColumns
          detailSetting={detailSetting}
          widgetId={widgetId!}
          isAudienceQuery={isAudienceQuery!}
        />
      )

    case InsightContentType.CROSSTAB_SHARE_OF_ROWS:
      return (
        <ShareOfRows
          detailSetting={detailSetting}
          widgetId={widgetId!}
          isAudienceQuery={isAudienceQuery!}
        />
      )

    case InsightContentType.CROSSTAB_COLUMN_AVERAGE_DIFF:
      return (
        <ColumnAverageDiff
          detailSetting={detailSetting}
          widgetId={widgetId!}
          isAudienceQuery={isAudienceQuery!}
        />
      )

    case InsightContentType.CROSSTAB_ROW_AVERAGE_DIFF:
      return (
        <RowAverageDiff
          detailSetting={detailSetting}
          widgetId={widgetId!}
          isAudienceQuery={isAudienceQuery!}
        />
      )

    case InsightContentType.OVERALL_STAR_RATINGS_AVERAGE:
      return (
        <OverallStarRatingsAverage
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
        />
      )

    case InsightContentType.OVERALL_SURVEY_SCORES_AVERAGE:
      return (
        <OverallSurveyScoresAverage
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
        />
      )

    case InsightContentType.MEASURE_WITH_LOCAL_TIME:
      return (
        <MeasureWithLocalTime
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
          timeUnits={timeUnits}
          forceNotScale={forceNotScale}
        />
      )

    case InsightContentType.MEASURE_WITH_SENTIMENT:
      return (
        <MeasureWithSentiment
          detailSetting={detailSetting}
          countType={countType || CountType.MENTIONS}
          timeUnits={timeUnits}
          forceNotScale={forceNotScale}
        />
      )
    case InsightContentType.NET_SENTIMENT:
      return (
        <NetSentiment
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
          timeUnits={timeUnits}
        />
      )
    case InsightContentType.NAME_MEASURE_BY:
      return (
        <NameMeasureBy
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
          forceNotScale={forceNotScale}
        />
      )
    case InsightContentType.NAME_MEASURE:
      return (
        <NameMeasure
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
          renderTitleContent={renderNameMeasureTitleContent}
          forceNotScale={forceNotScale}
        />
      )
    case InsightContentType.NAME_MEASURE_WITH_SHARE_OF_INSIGHTS:
      return (
        <NameMeasureWithShareOfInsights
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
          renderTitleContent={renderNameMeasureTitleContent}
        />
      )
    case InsightContentType.NAME_MEASURE_WITH_SHARE_OF_SENTIMENT:
      return (
        <NameMeasureWithShareOfSentiment
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
        />
      )
    case InsightContentType.MEASURE_WITH_INSIGHTS:
      return (
        <MeasureWithInsight
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
        />
      )
    case InsightContentType.CROSSTAB_SELECTED_ITEM_MEASURE:
      return (
        <SelectedItemMeasure
          detailSetting={detailSetting}
          widgetId={widgetId!}
          isAudienceQuery={isAudienceQuery!}
        />
      )
    case InsightContentType.SOUND_BITE:
      return <Soundbite detailSetting={detailSetting} />
    case InsightContentType.HEADER_TWEET_SOUND_BITE:
      return <Soundbite detailSetting={detailSetting} enableHeaderTweet />
    case InsightContentType.REPLIES:
      return <Replies detailSetting={detailSetting} />
    case InsightContentType.REPOSTS:
      return <Reposts detailSetting={detailSetting} />
    case InsightContentType.COMMENT:
      return <Comment detailSetting={detailSetting} />
    case InsightContentType.TOPIC_COMPARISON:
      return <TopicComparison detailSetting={detailSetting} isAudienceQuery={isAudienceQuery} />

    case InsightContentType.TRENDING_TOTAL_MEASURE:
      return (
        <TrendingTotalMeasure
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
        />
      )
    case InsightContentType.TRENDING_SINGLE_MEASURE:
      return (
        <TrendingSingleMeasure
          detailSetting={detailSetting}
          countType={countType || CountType.POSTS}
          widgetId={widgetId!}
          renderTitleContent={renderNameMeasureTitleContent}
        />
      )
    case InsightContentType.MENTIONS:
      return <Mentions detailSetting={detailSetting} />
    default:
      return null
  }
}

export default getInsightContent
